const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function designReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_DESIGN':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_DESIGN':
			return {
				...state,
				list: action?.payload?.designs || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default designReducer;
